export interface CustomTag {
    type: 'tag',
    id: string,
    attributes: CustomTagAttribute;
    showEditIcon?: boolean;
    query?: string;
}

export interface CustomTagAttribute {
    color: string;
    name: string | undefined;
    type: 'shipment' | 'warehouse-receipt' | 'cargo-detail' | 'cargo-release' | 'pickup-order' | 'purchase-order';
    type_id?: string[];
    upsert?: boolean;
    is_system_tag: boolean;
}

export interface SearchCustomTag {
    id: string;
    name: string;
    relevance: number;
    query?: string;
}
